// 已合成的奖励记录状态
export enum BenefitRecordAwardStatus {
  BenefitRecordAwardStatusEnum = 0,
  Pending = 1, // 待领取
  Delivering = 2, // 发货中
  Delivered = 3, // 已发货
  Failed = 4, // 发货失败
}

export enum FragmentsUsedType {
  FRAGMENTS_USED_TYPE = 0,
  USER_USE = 1,
  EXPEND = 2
}
